export const APP_NAME = "IncassaFlow";
export const APP_TAGLINE = "Solleciti pagamento via Email e WhatsApp";
